<template>
    <div class="LogManagementDetail">
        <div class="LogManagementDetail-title">
            <Breadcrumb>
                <BreadcrumbItem>{{this.$route.query.accountTypeName}}</BreadcrumbItem>
                <BreadcrumbItem>{{this.$route.query.accountName}}</BreadcrumbItem>
                <BreadcrumbItem>{{this.$route.query.logstoreName}}</BreadcrumbItem>
                <BreadcrumbItem to="/monitor/logManagementMonitor">{{ $t('alarms.logService.logService') }}</BreadcrumbItem>
            </Breadcrumb>
        </div>
        <Row type="flex" justify="space-between" class="code-row-bg">
            <Col span="6">
                <Card style="height: 480px;">
                    <Row>
                        <Row style="height: 240px;">
                            <Col span="24" style="text-align: center;font-size: 103px;display: block;margin-top: 8px;">
                                <img :src="protectEasyLogo" style="width: 83px;">
                            </Col>
                            <Col style="text-align: center;font-size:18px;">{{this.$route.query.logstoreName}}</Col>
                        </Row>
                        
                        <Row style="margin-bottom: 20px;">
                            <Col>{{ $t('alarms.logService.logServiceDescription') }}</Col>
                            <Col>---</Col>
                        </Row>
                        <Row>
                            <Col style="margin-bottom: 8px;">{{ $t('alarms.logService.logServiceConfiguration') }}</Col>
                            <Row>
                                <Col span="8">{{ $t('alarms.logService.projectName') }}:</Col>
                                <Col span="16">{{projectName}}</Col>
                            </Row>
                        </Row>
                    </Row>
                </Card>
            </Col>
            <Col span="13">
                <Card style="height: 480px;">
                    <ul class="content">
                        <li>
                            <Row>
                                <Col span="12">
                                    <Col span="4">
                                        <Button shape="circle" icon="ios-laptop"></Button>
                                    </Col>
                                    <Col span="20">
                                        <Row>
                                            <Col>{{ $t('alarms.logService.configurationInformation') }}</Col>
                                            <Row class="host">
                                                <Col>
                                                    <ul>
                                                        <li>{{ $t('alarms.logService.logName') }}：</li>
                                                        <li>{{logstoreName}}</li>
                                                    </ul>
                                                </Col>                                                
                                            </Row>
                                        </Row>
                                    </Col>
                                </Col>
                                <Col span="12">
                                    <Col span="4">
                                        <Button shape="circle" icon="ios-pulse"></Button>
                                    </Col>
                                    <Col span="20">
                                        <Row>
                                            <Col>{{ $t('alarms.common.monitorMessage') }}</Col>
                                            <Row class="host">
                                                <Col>
                                                    <ul>
                                                        <li>{{ $t('alarms.common.monitorItems') }}：</li>
                                                        <li>{{monitoringNum}}{{ $t('alarms.common.count') }}</li>
                                                    </ul>
                                                </Col>
                                                 <Col>
                                                    <a @click="monitorMQ">{{ $t('alarms.common.viewMonitoringOverview') }}</a>
                                                </Col>
                                            </Row>
                                        </Row>
                                    </Col>
                                </Col>
                            </Row>
                        </li>
                    </ul>
                </Card>
            </Col>
             <Col span="4">
                <Card style="height: 480px;">
                    <Row>
                        <Row style="margin-bottom: 10px;">
                            <Col>{{ $t('alarms.common.tags') }}</Col>
                        </Row>
                        <Row>
                            <Col v-for="(item,index) in tagList" v-bind:key="index">
                                <Tag color="default">{{item.key}} : {{item.value}}</Tag>
                            </Col>
                        </Row>
                    </Row>
                </Card>
            </Col>
        </Row>
    </div>
</template>

<script>
    import utils from '../../../utils/utils.js'
    export default {
        name: 'LogManagementDetail',
        data(){
            return {
                id:'',
                accountId:'',
                projectName:'',
                logstoreName:'',
                region:'',
                tagList:[],
                logstoreName:'',
                projectName:'',
                accountTypeName:'',
                accountName:'',
                protectEasyLogo: require('../../../../static/images/logManagement.png'),
                monitoringNum:''
            }
        },
        mounted () {
            this.queryLogDetails();
        },
        methods: {
            // 通过projectName查询实例
            queryLogDetails:function(){
                this.$api.log.queryLogDetails({
                    "accountId": this.$route.query.accountId,
                    "projectName": this.$route.query.projectName,
                    "logstoreName": this.$route.query.logstoreName,
                    "monitorModule": 17
                })
                .then(res => {
                    this.logstoreName=res.data.logstoreName;
                    this.projectName=res.data.projectName;
                    this.monitoringNum=res.data.monitoringNum;
                });
            },
            // 点击查看监控概览
            monitorMQ: function(){
                this.id = this.$route.query.id;
                this.accountId=this.$route.query.accountId;
                this.projectName=this.$route.query.projectName;
                this.logstoreName=this.$route.query.logstoreName;
                this.region=this.$route.query.region;
                this.accountName=this.$route.query.accountName;
                this.accountTypeName=this.$route.query.accountTypeName;
                this.$router.push({path:'/monitor/logManagement/',query: {id: this.id,accountId:this.accountId,projectName:this.projectName,logstoreName:this.logstoreName,region:this.region,accountTypeName:this.accountTypeName,accountName:this.accountName}});
            }
        }
        
    }
</script>

<style scoped>
    .LogManagementDetail-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 15px 4px;
        font-weight: 600;
    }
    .ivu-breadcrumb {
        font-size: 13px;
        font-weight: 600;
        color: #515a6e;
    }
    .host ul
    {
        list-style: none;
        overflow: hidden;
    }
    .host ul li
    {
        float: left;
    }
    .content>li
    {
        margin-bottom: 6px;
        border-bottom: 1px dashed #ccc;
        padding: 12px;
    }
    .content>li:last-child
    {
        border:none;
    }

</style>



// WEBPACK FOOTER //
// src/components/monitor/log_management/LogManagementDetail.vue